export default "__VITE_ASSET__d1da9f0f__"